import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const BulkUnitModal = ({ 
  open, 
  onOpenChange, 
  equipment, 
  locations, 
  api, 
  onSuccess 
}) => {
  const [bulkUnitForm, setBulkUnitForm] = useState({
    location_id: '',
    serial_numbers: ''
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setBulkUnitForm({ location_id: '', serial_numbers: '' });
    }
  }, [open]);

  const handleSaveBulkUnits = async () => {
    if (!bulkUnitForm.location_id || !bulkUnitForm.serial_numbers.trim()) {
      toast.error('Ubicación y números de serie son requeridos');
      return;
    }

    setSaving(true);
    try {
      const serials = bulkUnitForm.serial_numbers.split('\n').map(s => s.trim()).filter(Boolean);
      await api().post(`/equipment/${equipment.id}/units/bulk?location_id=${bulkUnitForm.location_id}`, serials);
      toast.success(`${serials.length} unidades creadas`);
      onSuccess?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear unidades');
    } finally {
      setSaving(false);
      onOpenChange(false);
    }
  };

  const handleClose = () => {
    setBulkUnitForm({ location_id: '', serial_numbers: '' });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Agregar Múltiples Unidades</DialogTitle>
          <DialogDescription>
            {equipment?.name} - Ingresa un número de serie por línea
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Ubicación *</Label>
            <Select value={bulkUnitForm.location_id} onValueChange={(v) => setBulkUnitForm({ ...bulkUnitForm, location_id: v })}>
              <SelectTrigger><SelectValue placeholder="Seleccionar ubicación" /></SelectTrigger>
              <SelectContent>
                {locations.map(loc => (
                  <SelectItem key={loc.id} value={loc.id}>{loc.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Números de Serie (uno por línea) *</Label>
            <Textarea 
              value={bulkUnitForm.serial_numbers} 
              onChange={(e) => setBulkUnitForm({ ...bulkUnitForm, serial_numbers: e.target.value })} 
              placeholder="SN-001&#10;SN-002&#10;SN-003"
              rows={6}
              className="font-mono text-sm"
            />
            <p className="text-xs text-muted-foreground">
              Cada línea será una unidad individual con status "Disponible"
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSaveBulkUnits} disabled={saving} className="btn-primary">
            {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Crear Unidades
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkUnitModal;
